import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// #region agent log
fetch('http://127.0.0.1:7242/ingest/4d17c952-1953-4e49-b749-522922e78936',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'C',location:'src/index.tsx:6',message:'index bootstrap',data:{reactVersion:React.version,hasRoot:Boolean(document.getElementById('root'))},timestamp:Date.now()})}).catch(()=>{});
// #endregion agent log

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// #region agent log
fetch('http://127.0.0.1:7242/ingest/4d17c952-1953-4e49-b749-522922e78936',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre-fix',hypothesisId:'C',location:'src/index.tsx:11',message:'root created',data:{rootType:typeof root},timestamp:Date.now()})}).catch(()=>{});
// #endregion agent log
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
